import { render, staticRenderFns } from "./sub-app-aside.vue?vue&type=template&id=03033bf0"
import script from "./sub-app-aside.vue?vue&type=script&lang=js"
export * from "./sub-app-aside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports